import React from "react";
import ReusableDataTable from "../../hooks/ReusableDataTable";
import { Button, Label, Modal, TextInput, Avatar, FileInput } from "flowbite-react";
import { useState, useEffect } from "react";
import '../../style/model.css';
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import useInputValidation from "../../hooks/useInputValidation";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import axios from "axios";
import { useSidebar } from "../../context/SidebarOpenContext";

function Colour() {
    
    const [AddModal, setAddModal] = useState(false);
    const [EditModal, setEditModal] = useState(false);
    const [DeleteModal, setDeleteModal] = useState(false);
    const [Input, setInput] = useState({colorname:"",cimage:""});
    const [Colour, setColour] = useState({});
    const { errors, handleChange, resetErrors } = useInputValidation();
   const { isSidebarOpen, toggleSidebar } = useSidebar();
    const url = localStorage.getItem("url");

    useEffect(() => {
        fetchColour();
    }, []);


    const onChangeValue = (e) => {
        handleChange(e);
        setInput({ ...Input, [e.target.name]: e.target.value });
    }

    const fetchColour = async () => {
        try {
            const response = await axios.get("master/colours");
            const ColourData = response.data;
            setColour(ColourData);
        } catch (error) {
            console.error("Error fetching Colour data:", error);
        }
    };

    const addColour = async (event) => {
        event.preventDefault();
    
        const formData = new FormData();
        formData.append('colour_name', Input.colorname);
        formData.append('colour_image', Input.cimage);
    
        try {
            // Show 3-second loader
            Swal.fire({
                title: "Creating...",
                text: "Please wait",
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading();
                },
                timer: 3000,
                timerProgressBar: true,
            });
    
            await new Promise((resolve) => setTimeout(resolve, 3000));
    
            const res = await axios.post(`master/colours`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
    
            if (res.data.success === 1) {
                Swal.fire({
                    icon: "success",
                    text: "Colour Way Created",
                    timer: 2000,
                    showConfirmButton: false,
                });
                setAddModal(false);
                fetchColour();
            } else if (res.data.success === 2) {
                Swal.fire({
                    icon: "error",
                    text: "Colour Way already exists...",
                    timer: 2000,
                    showConfirmButton: false,
                });
            } else {
                Swal.fire({
                    icon: "error",
                    text: "Server Problem. Please Try Again...",
                    timer: 2000,
                    showConfirmButton: false,
                });
            }
        } catch (error) {
            console.error("Error adding colour:", error);
            Swal.fire({
                icon: "error",
                text: "Something went wrong!",
                timer: 2000,
                showConfirmButton: false,
            });
        }
    };
    

    const UpdateColour = async (event) => {
        event.preventDefault();
    
        const formData = new FormData();
        formData.append('colour_name', Input.colorname);
        formData.append('colour_image', Input.cimage);
    
        try {
            // Show loader for 3 seconds
            Swal.fire({
                title: "Updating...",
                text: "Please wait",
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading();
                },
                timer: 3000,
                timerProgressBar: true,
            });
    
            // Wait for the loader to complete
            await new Promise((resolve) => setTimeout(resolve, 3000));
    
            const res = await axios.put(`master/colours/${Input.id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
    
            if (res.data.success === 1) {
                Swal.fire({
                    icon: "success",
                    text: "Colour Way Details Updated",
                    timer: 2000,
                    showConfirmButton: false,
                });
                setEditModal(false);
                fetchColour();
            } else {
                Swal.fire({
                    icon: "error",
                    text: "Server Problem. Please Try Again...",
                    timer: 2000,
                    showConfirmButton: false,
                });
            }
        } catch (error) {
            console.error("Error updating colour:", error);
            Swal.fire({
                icon: "error",
                text: "Something went wrong!",
                timer: 2000,
                showConfirmButton: false,
            });
        }
    };

    const deletColour = async () => {
        try {
            axios.delete(`master/colours/${Input.id}`).then((res) => {
                if (res.data.success === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Colour Way deleted",
                        type: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    fetchColour();
                    setDeleteModal(false);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: "Server Problem. Please Try Again...",
                        type: "error",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                }
                return;
            });
        } catch (error) {
            throw error;
        }
    };


    const data = Array.isArray(Colour)
        ? Colour.map((C) => ({
            id: C.colour_id,
            cname: C.colour_name,
            cimage:C.colour_image,
            option: (<div style={{ display: "flex" }}>
                <FaPen className="text-amber-400 text-xl" onClick={() => {
                    setEditModal(true); setInput({
                        id: C.colour_id,
                        colorname: C.colour_name,
                        colour_image: C.colour_image,
                    });
                }} />
                <MdDeleteForever className="ml-2 text-red-500 text-2xl" onClick={() => { setDeleteModal(true); setInput({ id: C.colour_id }) }} />
            </div>)
        }))
        : [];

    const columns = [
        { name: "S.No", selector: (row, index) => index + 1, sortable: true },
        { name: "Colour Way Name", selector: (row) => row.cname, sortable: true },
        {name: "Colour Way Image", selector: (row) => row.cimage,cell: row => (  
            <Avatar 
            img={`${url}${row.cimage}`}
            alt={row.colour_name} 
        /> )},
        { name: "Option", selector: (row) => row.option },
    ];

    return (

        <div className={` ${ isSidebarOpen  ? "p-4 sm:ml-64 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >
            <div className="p-4 rounded-lg dark:border-gray-700  mt-14">
                <div className="p-4 rounded-lg shadow bg-white">
                    <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold " onClick={() => setAddModal(true)} >Add Colour</Button>
                    <ReusableDataTable
                        title="Colour List"
                        columns={columns}
                        data={data}
                        className="pt-2"
                    />
                </div>
            </div>

            <Modal show={AddModal} size="md" onClose={() => {setAddModal(false);resetErrors();}} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Add Colour</h3>
                        <form onSubmit={addColour}>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.colorname && "failure"} value="Colour Way Name" />
                                </div>
                                <TextInput
                                    id="cname"
                                    name="colorname"
                                    placeholder=""
                                    type="text"
                                    color={errors.colorname && "failure"}
                                    helperText={
                                        errors.colorname && (
                                            <>
                                                <span className="font-medium"></span> {errors.colorname}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                      pattern="^[A-Za-z0-9\s]*$"
                                    required
                                />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="file" value="Colour Way Image" />
                                </div>
                                <FileInput id="file" name="cimage" onChange={(e) => setInput({ ...Input, [e.target.name]: e.target.files[0], })} />
                            </div>
                            <div className="pt-2 w-full flex justify-center">
                                <Button className="bg-icon-color  text-sidebar-color drop-shadow-md   font-bold" type="submit">Submit</Button>
                                <Button className="ml-2" color="gray" onClick={() => {setAddModal(false);resetErrors();}}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={EditModal} size="md" onClose={() => {setEditModal(false);resetErrors();}} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Update Colour</h3>
                        <div className="flex justify-center items-center">
                            <Avatar
                                img={`${url}${Input.colour_image}`}
                                alt={Input.colorname}
                            />
                        </div>

                        <form onSubmit={UpdateColour}>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.colorname && "failure"} value="Colour Way Name" />
                                </div>
                                <TextInput
                                    id="cname"
                                    name="colorname"
                                    placeholder=""
                                    type="text"
                                    color={errors.colorname && "failure"}
                                    helperText={
                                        errors.colorname && (
                                            <>
                                                <span className="font-medium"></span> {errors.colorname}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                      pattern="^[A-Za-z0-9\s]*$"
                                    required
                                    value={Input.colorname}
                                />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="file" value="Colour Way Image" />
                                </div>
                                <FileInput id="file" name="cimage" onChange={(e) => setInput({ ...Input, [e.target.name]: e.target.files[0], })} />
                            </div>
                            <div className="pt-2 w-full flex justify-center">
                                <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" type="submit">Submit</Button>
                                <Button className="ml-2" color="gray" onClick={() => {setEditModal(false);resetErrors();}}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={DeleteModal} size="md" onClose={() => setDeleteModal(false)} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            Are you sure you want to delete this colour?
                        </h3>
                        <div className="flex justify-center gap-4">
                            <Button color="failure" onClick={() => deletColour()}>
                                {"Yes"}
                            </Button>
                            <Button className="ml-2" color="gray" onClick={() => setDeleteModal(false)}>
                                No
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </div>


    );
}

export default Colour;
